import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-optionsdialog',
    standalone: false,
    templateUrl: './optionsdialog.component.html',
    styleUrls: ['./optionsdialog.component.scss'],
})
export class OptionsdialogComponent {
    constructor(
        public dialogRef: MatDialogRef<OptionsdialogComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    close(option: number | null): void {
        this.dialogRef.close(option);
    }

    getGerade(i) {
        if (i % 2 === 1) {
            return true;
        }
        return false;
    }
}
